import { Phone, MessageCircle, Clock } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { CONTACT } from "@/i18n/content";
import { Reveal, MaskedLines } from "./Reveal";

export const Contact = () => {
  const { t } = useLang();
  const c = t.contact;

  return (
    <section id="contact" data-testid="contact-section" className="py-24 md:py-36">
      <div className="mx-auto max-w-[1440px] px-6 md:px-12">
        <Reveal>
          <p className="overline mb-6">{c.overline}</p>
        </Reveal>
        <h2 className="heading-serif whitespace-pre-line text-4xl leading-[1.0] tracking-tight text-forest sm:text-6xl lg:text-7xl">
          <MaskedLines lines={c.title.split("\n")} trigger="load" />
        </h2>

        <Reveal delay={0.1}>
          <p className="body-text mt-8 max-w-xl">{c.body}</p>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 gap-px overflow-hidden rounded-3xl border border-line bg-line md:grid-cols-3">
          <a
            href={CONTACT.tel}
            data-testid="contact-call-btn"
            className="contact-tile group bg-bg p-8 md:p-10"
          >
            <Phone size={24} strokeWidth={1.4} className="text-terracotta" />
            <span className="overline mt-6 block">{c.callLabel}</span>
            <span className="heading-serif mt-2 block text-2xl text-forest transition-colors group-hover:text-terracotta md:text-3xl">
              {CONTACT.phoneDisplay}
            </span>
          </a>

          <a
            href={CONTACT.whatsapp}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="contact-whatsapp-btn"
            className="contact-tile group bg-bg p-8 md:p-10"
          >
            <MessageCircle size={24} strokeWidth={1.4} className="text-sage" />
            <span className="overline mt-6 block !text-sage">WhatsApp</span>
            <span className="heading-serif mt-2 block text-2xl text-forest transition-colors group-hover:text-sage md:text-3xl">
              {c.whatsappLabel}
            </span>
          </a>

          <div className="bg-bg p-8 md:p-10">
            <Clock size={24} strokeWidth={1.4} className="text-ink-soft" />
            <span className="overline mt-6 block">{c.hoursLabel}</span>
            <span className="heading-serif mt-2 block text-xl text-forest md:text-2xl">
              {c.hours}
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};
